import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const item = isSuccessResponse(response)
  return {
    chiper: item?.chiper,
    entityId: item?.entityId,
    id: item?.id?.toString() ?? '',
    instrumentType: item?.instrumentType,
    reqType: item?.reqType ?? '',
    mcfg1: item?.mcfg1,
    mcfg2: item?.mcfg2,
    meCode: item?.meCode,
    merchantId: item?.merchantId,
    pgSecurityId: item?.pgSecurityId,
    mappingStatus: item?.mappingStatus ? 'Activated' : 'Deactivated',
    secret: item?.secret,
    txnType: item?.txnType,
  }
}

const getMerchantById = (id: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getMerchantMappingById),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      id,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getMerchantById }
